import React from 'react';
import { connect, ConnectedProps } from 'react-redux';

import { RootState } from '../../lib/store';

import ArrowIcon from '../../assets/img/chevron.svg';

import styles from './UserDetails.module.scss';

const UserDetails = ({ individual }: ReduxProps) => {
  const transformName = () => {
    if (individual && individual.first_name?.length + individual.last_name?.length > 100) {
      return ([individual?.first_name[0], '. ', individual?.last_name].join(''));
    }
    return ([individual?.first_name, individual?.last_name].join(' '));
  };

  return (
    <div className={styles.user}>
      <div className={styles.name}>{transformName()}</div>
      <img src={ArrowIcon} className={styles.arrow} alt="arrow" />
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  individual: state.crm.individualExtendedInfo,
});

const connector = connect(mapStateToProps);
type ReduxProps = ConnectedProps<typeof connector>;

export default connector(UserDetails);
